import { Badge, Fab } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";
import theme from "../theme";

const badgeStyle = {
  position: "absolute",
  bottom: 16,
  right: 16,
};

const fabStyle = {
  backgroundColor: theme.palette.common.white,
};

interface GoToBottomProps {
  content: number;
  onClick: () => void;
}

const GoToBottom = ({ content, onClick }: GoToBottomProps) => {
  return (
    <Badge
      sx={badgeStyle}
      badgeContent={content}
      color="primary"
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <Fab sx={fabStyle} aria-label="add" size="medium" onClick={onClick}>
        <ExpandMoreIcon color="disabled" />
      </Fab>
    </Badge>
  );
};

export default GoToBottom;
